import { ReactComponent as LockIcon } from "../../../assets/lock.svg";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Input from "../../../component/common/Input";
import Button from "../../../component/common/Button";
import httpServices from "../../../services/httpServices";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useEffect } from "react";

import * as yup from "yup";

const Schema = yup.object().shape({
  email: yup.string().email().required("Email is required"),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters long")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/\d/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Password must contain at least one special character"
    ),

  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
});

const ChangePassword = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Function to get query parameters
  const getQueryParams = (url) => {
    const params = new URLSearchParams(url.search);
    return {
      email: params.get("email"),
      token: params.get("token"),
    };
  };
  const { token, email } = getQueryParams(location);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    clearErrors,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(Schema),
  });
  useEffect(() => {
    setValue("email", email);
  }, [email]);

  const handleResetPassword = async (data) => {
    const toastId = toast.loading("Resetting password...");

    try {
      const { response } = await httpServices.post(
        `/users/resetPassword`,
        {
          emailId: email,
          newPassword: data.password,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.update(toastId, {
          render: "Password Changed successfully!",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
        navigate("/login");
      }
    } catch (error) {
      console.log("Error", error);
      toast.update(toastId, {
        render: "Error resetting password",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };
  const onError = (errors) => {
    console.log("errors", errors);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-white p-[10px] sm:p-10">
      <div className="card w-[491px]">
        <h1 className="heading">Reset Password 🔐</h1>
        <>
          <form onSubmit={handleSubmit(handleResetPassword, onError)}>
            <div className="mt-[20px] space-y-6 mb-[20px] sm:mb-[41px]">
              <Input
                name="password"
                type="password"
                {...register("password")}
                Icon={LockIcon}
                label={"Enter New Password"}
                placeholder={"Password (min. 8 characters)"}
                onChange={(e) => {
                  clearErrors(["password"]);
                }}
              />
              {errors.password && (
                <p className="text-red-500 text-sm">
                  {errors.password.message}
                </p>
              )}
              <Input
                name="confirmPassword"
                type="password"
                {...register("confirmPassword")}
                Icon={LockIcon}
                label={"Confirm Password"}
                placeholder={"Retype password"}
                onChange={(e) => {
                  clearErrors(["confirmPassword"]);
                }}
              />
              {errors.confirmPassword && (
                <p className="text-red-500 text-sm">
                  {errors.confirmPassword.message}
                </p>
              )}
            </div>

            <Button
              type="submit"
              content="Reset Password"
              classes="hover:bg-[#3872A5] duration-300 justify-center  w-full"
            />
          </form>
        </>
      </div>
    </div>
  );
};

export default ChangePassword;
